import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';

@Injectable()
export class TablePaginator  extends MatPaginatorIntl {
	routeSubscription: Subscription;
	
	constructor(private translateService: TranslateService) {
		super();  

		this.translateService.get('common.table.paginator.title').subscribe((text: string) => {
			this.itemsPerPageLabel = text;
			this.changes.next();
		});					
	}

	getRangeLabel = (page: number, pageSize: number, length: number) =>  {
		if (length === 0 || pageSize === 0) {
			return `0 / 0`;
		}
		length = Math.max(length, 0);
		const startIndex = page * pageSize;
		const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
		return `${startIndex + 1} - ${endIndex} / ${length}`;
	}
}